import { DlgTitleWithCloseBtn } from 'ctls/modal/DlgTitleWithCloseBtn';
import { Modal, ModalWrap } from 'ctls/modal/Modal';
import { usePromise } from 'hooks/usePromise';
import { useRefComponent } from 'hooks/useRefComponent';
import { ta, tc } from 'language/i18nkey';
import { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { Radio } from './radio/Radio';

/**
 * 문서 그룹 설저.
 * 모바일, 데스크톱 팝업 레이아웃 다르게.
 */

type Props = {
  show(p: { cmd: 'cmd-new' | 'cmd-copy'; lang: string }): Promise<{ fromLang: string; toLang: string } | null>;
};
export const PopNewDoc = forwardRef<Props, {}>((props, ref) => {
  const [visible, setVisible] = useState(false);
  const promise = usePromise<{}, { cmd?: string }>();

  const [cmd, setCmd] = useState<'cmd-new' | 'cmd-copy'>('cmd-new');
  const [fromLang, setFromLang] = useState<string>('');

  const [toLang, setToLang] = useState<string>('');

  useImperativeHandle(ref, () => ({
    show: (p: { cmd: 'cmd-new' | 'cmd-copy'; lang: string }) => {
      setCmd(p.cmd);
      return new Promise((resolve, reject) => {
        promise.current = { resolve, reject };
        setFromLang(p.lang);
        setToLang('');
        setVisible(true);
      });
    },
  }));

  const handleClose = () => {
    setVisible(false);
    promise.current.reject({ cmd: 'close' });
  };

  const handleSelect = () => {
    promise.current.resolve({ fromLang, toLang });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Modal onClick={(e) => e.stopPropagation()}>
      <Body>
        <DlgTitleWithCloseBtn
          title={cmd === 'cmd-new' ? tc('i18n_doc_new') : tc('i18n_doc_copy')}
          onClose={handleClose}
        />
        <Cnts>
          <Guide>{cmd === 'cmd-new' ? tc('i18n_doc_new_desc') : tc('i18n_doc_copy_desc')}</Guide>

          <SubTitle>{tc('i18n_doc_region')}</SubTitle>

          <Radio
            label={ta('I18N_FILTER_KOREA')}
            name="newdoc-lang"
            value="ko-KR"
            fontSize="1.4rem"
            disabled={fromLang === 'ko-KR'}
            onChange={() => setToLang('ko-KR')}
          />
          <Radio
            label={ta('I18N_FILTER_GLOBAL')}
            name="newdoc-lang"
            value="en"
            fontSize="1.4rem"
            disabled={fromLang === 'en'}
            onChange={() => setToLang('en')}
          />
          <Radio
            label={ta('I18N_FILTER_USA')}
            name="newdoc-lang"
            value="en-US"
            fontSize="1.4rem"
            disabled={fromLang === 'en-US'}
            onChange={() => setToLang('en-US')}
          />
        </Cnts>
        <Bottom>
          <Btn onClick={() => handleSelect()}>{tc('i18n_confirm')}</Btn>
        </Bottom>
      </Body>
    </Modal>
  );
});

PopNewDoc.displayName = 'PopNewDoc';

const SubTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  color: #2a2c2f;
  padding: 1.1rem 0;
`;

export const usePopNewDoc = () => useRefComponent<Props>(PopNewDoc);

const Bottom = styled.div`
  padding: 0 3.2rem 2.3rem 3.2rem;
  text-align: center;
`;

const Guide = styled.div`
  font-size: 1.4rem;
  font-weight: 400;
  color: #2a2c2f;
  padding: 1.1rem 0;
`;

// const Scroll = styled.div`
//   overflow-y: auto;
//   flex-grow: 1;
// `;

const Cnts = styled.div`
  padding: 0 3.2rem 2.3rem 3.2rem;
  display: flex;
  height: 1px;
  flex-grow: 1;
  gap: 1.6rem;
  overflow-y: auto;
  flex-direction: column;
`;

const Body = styled(ModalWrap)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 38rem;
  max-width: 36rem;
  min-height: 38rem;
`;

const Btn = styled.button`
  width: 100%;
  max-width: 29.6rem;
  height: 4.8rem;
  font-size: 1.6rem;
  font-weight: 700;
  background-color: #123069;
  color: #fff;
  border-radius: 10rem;
  line-height: 4.8rem;
`;
